import { SetStateAction } from 'react';
import { useMediaQuery } from '../../layouts/Navbar/NavBar';
import ReviewCard from '../../shared-components/Reviews/ReviewCard';
import ReactPaginate from 'react-paginate';
import { LoadingSpinner } from '../../shared-components/LoadingSpinner/LoadingSpinner';
interface IProps {
  totalReviews: Record<string, any>;
  fetchReviewsLoading: any;
  currentPage: number;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
}
const DisplayReviews = ({
  totalReviews,
  currentPage,
  setCurrentPage,
  fetchReviewsLoading
}: IProps) => {
  const { strapi_reviews } = totalReviews;
  const { reviewsConnection } = totalReviews;
  const pageCounter = Math.ceil(
    (reviewsConnection?.aggregate?.count || 0) / 10
  );
  const handlePageClick = ({ selected }: any) => {
    setCurrentPage(selected);
  };
  const isMobile = useMediaQuery(640);
  const isTablet = useMediaQuery(1024);
  const isLaptop = useMediaQuery(1440);

  let itemsPerRow = 1;

  if (isMobile) {
    itemsPerRow = 1;
  } else if (isTablet) {
    itemsPerRow = 2;
  } else if (isLaptop) {
    itemsPerRow = 3;
  } else {
    itemsPerRow = 4;
  }

  const validReviews =
    strapi_reviews
      ?.filter((review: any) => {
        if (!review?.traveller || !review?.review) return false;

        // Filter out all reviews with rating < 4.5
        return parseFloat(review?.rating) >= 4.5;
      })
      ?.slice(0, 10) || [];

  const rows: any[][] = [];
  for (let i = 0; i < validReviews?.length; i += itemsPerRow) {
    rows?.push(validReviews?.slice(i, i + itemsPerRow));
  }

  return (
    <>
      <section
        id="reviews-display"
        className="flex flex-wrap w-[288px] min-h-[332px] xsm:w-[340px] md:w-[700px] xl:w-[1000px] 2xl:w-[1332px]  py-6 rounded-lg    mx-auto justify-start    md:gap-x-4 gap-y-6"
      >
        {fetchReviewsLoading && (
          <div className="flex justify-center items-center h-[200px] w-full">
            <LoadingSpinner className="w-10 h-10 border-primary mr-2" />
          </div>
        )}
        {strapi_reviews?.filter(
          (review: any) => review?.traveller && review?.review
        )?.length === 0 && (
          <div className="text-[24px] text-[#333333] font-[600] px-5 xsm:px-8 sm:px-16">
            No reviews Found
          </div>
        )}
        {rows?.map(row => {
          let maxImageCount = 0;

          row?.forEach((review: any) => {
            const imageLen = review?.image_urls?.length || 0;
            const reviewLen = review?.review?.length || 0;

            if (imageLen > maxImageCount) {
              maxImageCount = imageLen;
            }
          });

          return row?.map((review: any) => (
            <ReviewCard
              key={review?.id}
              review={review}
              rowImageCount={maxImageCount}
            />
          ));
        })}
      </section>
      {strapi_reviews?.filter(
        (review: any) => review?.traveller && review?.review
      )?.length !== 0 && (
        <section id="pagination">
          <div className="md:w-[65%] lg:w-[55%] xl:w-[49%] mx-auto md:ml-auto">
            <ReactPaginate
              forcePage={currentPage}
              breakLabel={<span className="sm:mr-3">...</span>}
              nextLabel={strapi_reviews?.length >= 10 ? '>' : ''}
              onPageChange={handlePageClick}
              activeClassName="bg-primary text-white"
              pageRangeDisplayed={isMobile ? 3 : 5}
              pageCount={pageCounter > 300 ? pageCounter - 10 : pageCounter}
              previousLabel={strapi_reviews?.length >= 10 ? '<' : ''}
              containerClassName="flex justify-center gap-2 sm:gap-6 my-4 sm:my-6 xl:my-8 pb-3"
              pageClassName="block hover:text-white hover:bg-[#2E3D7A] rounded-[2px] px-2"
              // @ts-ignore
              renderOnZeroPageCount={null}
            />
          </div>
        </section>
      )}
    </>
  );
};

export default DisplayReviews;
